<template>
    <div id="bar-chart">
      <b-card class="border-radius" style="max-height:26rem">
        <a :href="'#/leave?limit=25&order=createdAt&page=1'">
          <div class="pb-1" id="border-reimburse">
            <h5 id="barHeading">Leave</h5>
            <p id="barLabel">Weekly Stats</p>
          </div>
        </a>
        <div>
          <canvas ref="canvas" width="200" height="300"></canvas>
        </div>
      </b-card>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { Bar } from 'vue-chartjs'

  export default {
      extends: Bar,
      data () {
        return {
          dataChart: {
            labels: [],
            datasets: [
              {
                label: "Approved",
                // borderColor: 'rgb(0,128,0,0.1)',
                // backgroundColor: 'rgb(0,128,0,0.1)',
                borderColor: 'rgba(11,156,49,0.12)',
                backgroundColor: 'rgba(11,156,49,0.12)',
                fill: true,
                borderWidth: 2,
                hoverBorderWidth: 3,
                data: []
              },
              {
                label: "Rejected",
                borderColor: 'rgba(255, 0, 0, 0.1)',
                backgroundColor: 'rgba(255, 0, 0, 0.1)',
                fill: false,
                borderWidth: 2,
                hoverBorderWidth: 3,
                data: []
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                id: "leave",
                ticks: {
                  fontColor: "rgba(0,0,0,0.5)",
                  fontStyle: "bold",
                  beginAtZero: true,
                  // maxTicksLimit: 6,
                  max: 50,
                  padding: 10
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Amount',
                  fontStyle: "bold",
                }
              }],
              xAxes: [{
                gridLines: {
                  display: true
                },
                ticks: {
                  padding: 4,
                  fontColor: "rgba(0,0,0,0.5)",
                  fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                  fontSize: 10,
                  fontStyle: "bold"
                },
                scaleLabel: {
                  display: true,
                  padding: 6,
                  labelString: 'Date (D)',
                  fontStyle: "bold",
                }
              }]
            }
          }
        }
      },
      mounted () {
        this.getData()
      },
      methods: {
        getData() {
          this.$http.get(window.AppConfig.apiUrl + 'leave-count-stat').then(resp => {
            if (!resp.data) {
              this.$store.dispatch('notification/warning', 'No Data')
            } else {
              let foo = resp.data.leaveCountStat
              foo.forEach((response, key) => {
                this.dataChart.labels.push(response.date)
                this.dataChart.datasets[0].data.push(response.data.Approved)
                this.dataChart.datasets[1].data.push(response.data.Rejected)
                this.renderChart(this.dataChart, this.options)
              })
              // this.$emit('afterLoad', this.totalAmount)
            }
          });
        }
      }
  }
</script>